import { useDispatchGetCardDefaults } from 'dispatchers/dispatchers';
import { useEffect } from 'react';
import { useSelectAssignedGrandfatherClientNumber } from 'selectors/selectors';
import { useGetDefaultAccount } from './useGetDefaultAccount';

/**
 * This hook will handle automatically autofilling the form when there is only one account.
 */
export function useAutofillSingleAccount() {
  const getCardDefaults = useDispatchGetCardDefaults();
  const { defaultAccount, hasMultiple } = useGetDefaultAccount();
  const assignedGrandfatherClientNumber =
    useSelectAssignedGrandfatherClientNumber();

  useEffect(() => {
    if (!hasMultiple)
      getCardDefaults(defaultAccount, assignedGrandfatherClientNumber);
  }, []);
}
